import meshRestrictionHelper from "./meshRestrictionHelper";

class Restriction {
    type;
    blacklist;
    restriction;
    allowedTypesToPopulate;

    constructor({type, blacklist = {}, restriction = true, allowedTypesToPopulate = []}) {
        this.type = type;
        this.blacklist = blacklist;
        this.restriction = restriction;
        this.allowedTypesToPopulate = allowedTypesToPopulate;
    }

    addRestrictedItems(itemsArray) {
        itemsArray.forEach(item => {
            this.blacklist[item] = true;
        });
    }

    removeRestrictedItems(itemsArray) {
        itemsArray.forEach(item => {
            delete this.blacklist[item];
        });
    }

    isValid(item = "") {
        if (!this.restriction) return true;

        return !this.blacklist[item];
    }

    updateRestrictionStatus(status) {
        this.restriction = status;
    }

    getPopulatedDataByType() {
        throw new Error('Sub class responsibility');
    }

    updateDataBasedOnMode(mode, data) {
        switch (mode) {
            case meshRestrictionHelper.RestrictionMode.ALLOW_ALL:
                return this.clear();
            case meshRestrictionHelper.RestrictionMode.ALLOW:
                return this.removeRestrictedItems(data);
            case meshRestrictionHelper.RestrictionMode.DENY_ALL:
            case meshRestrictionHelper.RestrictionMode.DENY:
                return this.addRestrictedItems(data);
            default:
                return;
        }
    }

    clear() {
        this.blacklist = {};
    }
}

export default Restriction;